import Link, { type LinkProps } from '@mui/material/Link';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router';

import { isInternalPath, safeHref } from '@/utils/url';

export type AppLinkProps = Omit<LinkProps, 'href'> & { href: string };

/**
 * Internal paths route client-side; external links open safely in a new tab;
 * anything that is not http(s)/mailto/tel renders as plain text.
 */
export const AppLink = forwardRef<HTMLAnchorElement, AppLinkProps>(function AppLink(
  { href, children, ...rest },
  ref,
) {
  const safe = safeHref(href);
  if (!safe) return <span>{children}</span>;

  if (isInternalPath(safe)) {
    return (
      <Link ref={ref} component={RouterLink} prefetch="intent" to={safe} {...rest}>
        {children}
      </Link>
    );
  }

  const opensTab = safe.startsWith('http');
  return (
    <Link
      ref={ref}
      href={safe}
      {...(opensTab ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      {...rest}
    >
      {children}
    </Link>
  );
});
